import { html, css, LitElement, nothing } from 'lit';

import { customElement, property, state } from 'lit/decorators.js';
import {classMap} from 'lit/directives/class-map.js'

@customElement('whois-clamp-box')
export class ClampBox extends LitElement {
  static override styles = css`
    #content {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        cursor: pointer;

        -webkit-line-clamp: var(--whois-clamp-box-lines, 1);
        line-clamp: var(--whois-clamp-box-lines, 1);
    }
    #content.expanded {
        -webkit-line-clamp: unset;
        line-clamp: unset;
        cursor: auto;
    }
    .button {
        cursor: pointer;
        margin-top: 0;

        font-weight: var(--whois-clamp-box-button-weight, 500);
        font-family: var(--whois-clamp-box-button-font-family);
        font-size: var(--whois-clamp-box-font-size);
    }

    ::slotted(*) {
      content-visibility: visible !important;
    }
  `;

  @property() moreText = "...more"
  @property() lessText = "Show less"
  @property() lazyAttach = true;
  @state() private expanded = false

  constructor() {
    super();
  }

  override render() {
      const buttonText = this.expanded ? this.lessText : this.moreText
      
      return html`
        <div id="content" class="${classMap({"expanded":this.expanded})}" @click=${()=>this.toggle(true)}>
          ${!this.lazyAttach || this.expanded ? html`<slot></slot>` : nothing}
        </div>
        <p class="button" @click=${()=>this.toggle()} aria-expanded="${this.expanded}">${buttonText}</p>
    `
  }

  private toggle(expandOnly=false) {
    if(expandOnly && this.expanded) return;
    this.expanded = !this.expanded
  }
}
